const siteLayoutTheme = {
    layout: {
        maxSiteWidth: 1680,
    },
};

export default siteLayoutTheme;
